import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {
  Column,
  ContainerQuestion,
  Row,
  FieldName,
  FieldValue,
  LearnMoreLink,
  FieldQuestionRate,
  ColoredQuestionRating,
  QuestionOptionAnswerComponent,
  QuestionOptionPercentage,
} from '../styles';

const ScreenerRate = (props) => {
  const {
    title,
    question,
    questionIndex,
  } = props;

  return (
    <Row key={question.id}>
      <Column computer={4} tablet={4} mobile={8}>
        <FieldName>
          {`${title} ${questionIndex + 1}`}
        </FieldName>
        {question.screenerRatingPercentage ? (
          <ColoredQuestionRating percentage={question.screenerRatingPercentage}>
            {`${question.screenerRatingPercentage} of participants qualified`}
          </ColoredQuestionRating>
        ) : (
          <FieldQuestionRate>
            Pass rates unavailable
            <LearnMoreLink
              href="http://help.playbookux.com/en/articles/8225730-screen-survey-pass-rates"
              target="_blank"
            >
              Learn more
            </LearnMoreLink>
          </FieldQuestionRate>
        )}
      </Column>
      <Column computer={12} tablet={12} mobile={8}>
        <ContainerQuestion>
          <FieldName>
            {question.label}
          </FieldName>
        </ContainerQuestion>
        <ContainerQuestion>
          <FieldValue>
            {_.orderBy(question.questionOptions, ['order']).map((questionOption, optionIndex) => {
              let answerType = 'DISQUALIFY';
              if (!questionOption.disqualify && !questionOption.qualify) {
                answerType = 'MAY SELECT';
              }
              if (questionOption.qualify) {
                answerType = 'QUALIFY';
              }
              return (
                <QuestionOptionAnswerComponent key={questionOption.id}>
                  {`Answer ${optionIndex + 1}: ${questionOption.label} (${answerType})`}
                  {question.screenerRatingPercentage && (
                    <QuestionOptionPercentage>
                      {`${questionOption.optionRatingPercentage}`}
                    </QuestionOptionPercentage>
                  )}
                </QuestionOptionAnswerComponent>
              );
            })}
          </FieldValue>
        </ContainerQuestion>
      </Column>
    </Row>
  );
};

ScreenerRate.propTypes = {
  title: PropTypes.string.isRequired,
  question: PropTypes.shape(PropTypes.shape({})).isRequired,
  questionIndex: PropTypes.number.isRequired,
};

export default ScreenerRate;
